import { render, staticRenderFns } from "./RummyDistributorCommissionDashboard.vue?vue&type=template&id=0d2544bb"
import script from "./RummyDistributorCommissionDashboard.vue?vue&type=script&lang=js"
export * from "./RummyDistributorCommissionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports